import React, { useState, useEffect } from "react";
import {
  AddRounded,
  Favorite,
  StarBorder,
  StarRounded,
} from "@mui/icons-material";
import { actionType } from "../redux/reducer";
import { useStateValue } from "../redux/state_provider";
import {Items} from '../data/data'

let cart_data = [];
let total_price = 0;

const ITEM_CARD = ({ imgSrc, name, rattins, price, itemId }) => {
  const [Favorite_toggle, setFavorite_toggle] = useState(false);
  const [current_star, setcurrent_star] = useState();

  const [, dispatch] = useStateValue();
  const [isCart, setCart] = useState(null);

  function onSetStar(value) {
    setcurrent_star(value);
  }

  useEffect(() => {
    if (isCart) {
      cart_data.push(isCart);
      total_price = parseFloat(total_price) + parseFloat(isCart.price)
      dispatch({
        type: actionType.SET_CART,
        cart: cart_data,
      });
      dispatch({
        type: actionType.SET_TOTAL,
        total: total_price,
      });
    }
  }, [isCart, dispatch]);
  console.log(total_price);
  return (
    <div className="item_card" id={itemId}>
      <div
        className={`is_favorite ${Favorite_toggle ? "active" : ""}`}
        onClick={() => setFavorite_toggle(!Favorite_toggle)}
      >
        <Favorite />
      </div>

      <div className="img_box">
        <img src={imgSrc} className="item_img" alt="" />
      </div>

      <div className="item_content">
        <h3>{name}</h3>
        <div className="bottom">
          <div className="ratings">
            {Array.apply(null, { length: 5 }).map((items, key) => (
              <i key={key} onClick={() => onSetStar(key + 1)}>
                {current_star > key ? <StarRounded /> : <StarBorder />}
              </i>
            ))}
            <h3 className="item_price">
              <span>$</span> {price}
            </h3>
          </div>
          <i className="add_to_cart">
            <AddRounded
              onClick={() => setCart(Items.find((n) => n.id === itemId))}
            />
          </i>
        </div>
      </div>
    </div>
  );
};

export default ITEM_CARD;
